module.exports = __webpack_public_path__ + "img/bianjie2.daa2152a.png";